import { useState, useEffect, useMemo, useContext } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";

import TotalUsers from "./cloudtern/components/Dashboard/TotalUsers";
import Totallikes from "./cloudtern/components/Dashboard/Totallikes";
import Totaldislikes from './cloudtern/components/Dashboard/Totaldislikes'
import TotalSearches from "./cloudtern/components/Dashboard/TotalSearches";
import SignIn from './cloudtern/components/Dashboard/SignIn'
import SignUp from './cloudtern/components/Dashboard/SignUp'
import OAuthCallback from "./cloudtern/components/Dashboard/OAuthCallback";
import Error from "cloudtern/components/Dashboard/Error";
import notfoundimage from "./assets/images/404-image.svg"
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import Error1 from "cloudtern/components/Dashboard/Error1";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator, setLayout } from "context";

import brand from "assets/images/Anser.png";
import { RoutesContext } from "context/RoutesContext";

import Dashboard from './cloudtern/components/Dashboard';
import Users from 'cloudtern/components/Users';
import Searches from 'cloudtern/components/Searches'
import Likes from "cloudtern/components/Likes";
import Dislikes from 'cloudtern/components/Dislikes';
import Unanswered_questions from "cloudtern/components/Unanswered_questions";
import TotalEmails from "cloudtern/components/Emails";
import ContactUsActions from "cloudtern/components/ContactUs";

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';

import WebflowLayout from "cloudtern/components/Webflow/WebflowLayout";
import Auth from "cloudtern/components/Webflow/Auth";
import Settings from "cloudtern/components/Settings";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { useUser } from "context/UserContext";
import Registration from "cloudtern/components/Webflow/Registration";
import NotFound from "cloudtern/components/Webflow/NotFound";
import { Button, Card, CardContent, Typography } from "@mui/material";
import AnseraLogo from "assets/images/Anser.png";
import ConfirmPassword from "cloudtern/components/Webflow/ConfirmPassword";
import Signup from "cloudtern/components/Webflow/Signup";
import Customers from "cloudtern/components/CustomerSites";
import Pricing from "cloudtern/components/Dashboard/Pricing";
import { Equalizer, GraphicEq, MonetizationOn } from "@mui/icons-material";
import Onboarding from "cloudtern/components/Webflow/Onboarding";
import DomainsBySource from "cloudtern/components/Webflow/DomainsBySource";



export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const { queryString } = useContext(RoutesContext);
  const { googleUser } = useUser();
  const role = sessionStorage.getItem("role");

  const dashboardRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      route: "/dashboard",
      icon: <SpaceDashboardRoundedIcon size="12px" />,
      noCollapse: true,
      component: <Dashboard key="dashboard" />,
    },
    {
      type: "collapse",
      name: "Visitors",
      key: "visitors",
      route: "/visitors",
      icon: <PeopleAltRoundedIcon fontSize="10px" />,
      noCollapse: true,
      component: <Users key="visitors" />
    },
    {
      type: "collapse",
      name: "Queries",
      key: "queries",
      route: "/queries",
      icon: <SearchRoundedIcon fontSize="10px" />,
      noCollapse: true,
      component: <Searches key="queries" />
    },
    {
      type: "collapse",
      name: "Likes",
      key: "likes",
      route: "/likes",
      icon: <ThumbUpOutlinedIcon size="10px" />,
      noCollapse: true,
      component: <Likes key="likes" />,
    },
    {
      type: "collapse",
      name: "Dislikes",
      key: "dislikes",
      route: "/dislikes",
      icon: <ThumbDownAltOutlinedIcon size="10px" />,
      noCollapse: true,
      component: <Dislikes key="dislikes" />
    },
    {
      type: "collapse",
      name: "Unanswered",
      key: "unanswered",
      route: "/unanswered",
      icon: <ErrorOutlineIcon size="10px" />,
      noCollapse: true,
      component: <Unanswered_questions key="unanswered" />
    },
    {
      type: "collapse",
      name: "Emails Sent",
      key: "emails-sent",
      route: "/emails-sent",
      icon: <MailOutlineIcon size="10px" />,
      noCollapse: true,
      component: <TotalEmails key="emails-sent" />
    },
    {
      type: "collapse",
      name: "Contact Us Actions",
      key: "contact-us",
      route: "/contact-us",
      icon: <PermContactCalendarIcon size="10px" />,
      noCollapse: true,
      component: <ContactUsActions key="contact-us" />
    },
  ];

if ((googleUser || sessionStorage.getItem("custom") === "true") && (role == "read&write" || role == "admin")) {
  dashboardRoutes.push({
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <SettingsSuggestIcon size="10px" />,
    route: "/settings",
    noCollapse: true,
    component: <Settings key="settings" />,
  });
}


if(sessionStorage.getItem("is_super_admin")==="true"){

  dashboardRoutes.unshift({
    type: "collapse",
    name:"Customers",
    key:"customers",
    icon:<PeopleAltRoundedIcon fontSize="10px" />,
    route:"/customers",
    noCollapse:true,
    component:<Customers key="customers"/>,
  })

    dashboardRoutes.splice(1,0,{
    type: "collapse",
    name:"Pricing",
    key:"pricing",
    icon:<MonetizationOn fontSize="10px" />,
    route:"/pricing",
    noCollapse:true,
    component:<Pricing key="pricing"/>,
  })
  //     dashboardRoutes.unshift({
  //   type: "collapse",
  //   name:"Website Build",
  //   key:"website-build",
  //   icon:<Equalizer fontSize="10px" />,
  //   route:"/website-build",
  //   noCollapse:true,
  //   component:<DomainsBySource key="website-build"/>,
  // })

}


  const webflowRoutes = [
    {
      type: "collapse",
      name: "layouts",
      key: "layouts",
      route: "/layouts",
      icon: <i className="fas fa-rocket" />,
      noCollapse: true,
      component: <WebflowLayout />
    }
  ];

  const getCurrentRoutes = () => {
    switch (layout) {
      case "webflow":
        return webflowRoutes;
      case "dashboard":
      default:
        return dashboardRoutes;
    }
  };

  const routes = getCurrentRoutes();

  useEffect(() => {
    if (
      pathname === "/onboarding" ||
      pathname === "/login"
    ) {
      setLayout(dispatch, "webflow");
    } else if (
      pathname.startsWith("/dashboard") ||
      pathname.startsWith("/visitors") ||
      pathname.startsWith("/queries") ||
      pathname.startsWith("/likes") ||
      pathname.startsWith("/dislikes") ||
      pathname.startsWith("/unanswered") ||
      pathname.startsWith("/emails-sent") ||
      pathname.startsWith("/contact-us") ||
      pathname.startsWith("/settings")
    ) {
      setLayout(dispatch, "dashboard");
    }
  }, [pathname, dispatch]);

  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route) return <Route exact path={route.route} element={route.component} key={route.key} />;
      return null;
    });

  const getAllRoutes = () => [...dashboardRoutes, ...webflowRoutes];

  const getAllRoutePaths = () => {
    const flattenRoutes = (routesList) => {
      return routesList.reduce((acc, route) => {
        if (route.route) acc.push(route.route);
        if (route.collapse) acc.push(...flattenRoutes(route.collapse));
        return acc;
      }, []);
    };
    return flattenRoutes(getAllRoutes());
  };

  const allValidPaths = getAllRoutePaths();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const user = params.get("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      // console.log("Logged in as:", parsedUser);
    }
  }, []);

  const HIDE_SIDENAV_ROUTES = ["/", "/sign-in", "/sign-up", "/oauth-callback", "/login","/onboarding", "/Access-Denied", "/error", "/register","/404","/set-password","/signup"];
const navigate = useNavigate();
 
  const renderLayoutComponents = () => {
    const isHiddenRoute = HIDE_SIDENAV_ROUTES.includes(pathname);
    const isValidRoute = allValidPaths.includes(pathname);
    

    if (isHiddenRoute ) return null;
    if(!isValidRoute){
      return(
        <div style={{ display: "flex", justifyContent: "center", marginTop: "5rem" }}>
      <Card sx={{ maxWidth: 400, textAlign: "center", padding: "2rem" }}>
        <img src={notfoundimage} alt="Not Found"/>
        <CardContent>
          <img src={AnseraLogo} alt="Ansera Ai" style={{height:"30px",width:"60px"}}/>

          <Typography variant="body1" gutterBottom>
            The page you are looking for does not exist.
          </Typography>
          <Button
            variant="contained"
           
            onClick={() => navigate("/")}
             sx={{
                  padding: "10px 10px",
                  borderRadius: "8px",
                  backgroundColor: "#219297",
                  color: "#ffffff",
                  fontWeight: "bold",
                }}
          >
            Go Home
          </Button>
        </CardContent>
      </Card>
    </div>
      )
    }
    switch (layout) {
      case "dashboard":
      case "webflow":
        return (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName=" "
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
          </>
        );
      default:
        return null;
    }
  };

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={themeRTL}>
        <CssBaseline />
        {renderLayoutComponents()}
        <Routes>
          {getRoutes(getAllRoutes())}
          <Route path="/login" element={<Auth />} />
          <Route path="" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {renderLayoutComponents()}
      <Routes>
        {getRoutes(getAllRoutes())}
        <Route path="/" element={<Auth />} />
        <Route path="/login" element={<Auth />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/set-password" element={<ConfirmPassword />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/oauth-callback" element={<OAuthCallback />} />
        <Route path="/Access-Denied" element={<Error />} />
        <Route path="/error" element={<Error1 />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="" element={<Navigate to="/dashboard" />} />
        
      </Routes>
    </ThemeProvider>
  );
}
